import Cookies from "js-cookie";

// Decodifica o payload de um JWT sem biblioteca. Isto NAO valida assinatura --
// nem a versao anterior validava, jwt.decode tambem so decodifica.
// A autoridade sobre isAdmin e do backend (checkAdministratorPrivilege);
// aqui e apenas para decidir o que exibir na interface.
function decodeJwtPayload(token) {
  try {
    const part = String(token).split(".")[1];
    if (!part) return null;

    const base64 = part.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64 + "=".repeat((4 - (base64.length % 4)) % 4);

    const json = decodeURIComponent(
      atob(padded)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );

    return JSON.parse(json);
  } catch (error) {
    return null;
  }
}

// Cookie corrompido deixava o site inteiro em branco: jwt.decode devolvia null
// e payload.exp lancava TypeError dentro do useEffect do App, impedindo o
// setLoading(false). Agora qualquer falha retorna "nao autenticado" e limpa o
// cookie ruim, para o usuario nao ficar preso.
export default function Auth() {
  const denied = {
    userAuthenticated: false,
    adminAuthenticated: false,
    leagueLiderAuthenticated: false,
  };

  try {
    const raw = Cookies.get("Authorization");

    // 'undefined'/'null' como STRING sao valores reais que o interceptor
    // gravava quando o header nao vinha na resposta.
    if (!raw || raw === "undefined" || raw === "null") return denied;

    const parts = String(raw).split(" ");
    const token = parts.length > 1 ? parts[1] : parts[0];
    if (!token || token === "undefined") {
      Cookies.remove("Authorization");
      return denied;
    }

    const payload = decodeJwtPayload(token);
    if (!payload || typeof payload.exp !== "number") {
      Cookies.remove("Authorization");
      return denied;
    }

    if (payload.exp < Date.now() / 1000) return denied;

    return {
      userAuthenticated: true,
      adminAuthenticated: Boolean(payload.isAdmin),
      leagueLiderAuthenticated: payload.league_function === "lider",
    };
  } catch (error) {
    // Nenhuma falha aqui pode derrubar o App.
    console.error("Auth(): falha ao ler o token.", error);
    return denied;
  }
}
